import { render, staticRenderFns } from "./auditShopCommunity.vue?vue&type=template&id=53ceb1fc&scoped=true"
import script from "./auditShopCommunity.vue?vue&type=script&lang=js"
export * from "./auditShopCommunity.vue?vue&type=script&lang=js"
import style0 from "./auditShopCommunity.vue?vue&type=style&index=0&id=53ceb1fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ceb1fc",
  null
  
)

export default component.exports